// extracted by mini-css-extract-plugin
export default {"accessDenied":"ProtectedRoute_accessDenied__9U1HP"};